import Vue from 'vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueRx from 'vue-rx';
import Vuelidate from 'vuelidate';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs'; // Disposable if using RxJS4
import { Subject } from 'rxjs'; // required for domStreams option

import App from './App'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VTooltip from 'v-tooltip'


Vue.config.productionTip = false

Vue.use(VueRx, { Observable, Subscription, Subject });
Vue.use(BootstrapVue);
Vue.use(Vuelidate);

Vue.use(VTooltip)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js